import { Log, School } from '.';

export enum EStreamStatus {
  records = 'records',
  live = 'live'
}

export type AnswerReports = {
  id: string;
  isCorrect: boolean;
  learningExperienceName: string;
  learningExperienceId: string;
  roomId: string;
  stationNumber: string;
  userAnswer: string;
  userId: string;
  userName: string;
  timestamp: string;
  answeredAt: string;
};

export type ProgressReports = {
  id: string;
  lastCompletedStation: number;
  roomId: string;
  learningExperienceName: string;
  learningExperienceId: string;
  leTimeSpent: string;
  userId: string;
  userName: string;
  lastCompletionStationTimestamp: string;
  endAt: string;
  startAt: string;
  org: string;
  totalStationCount: number;
  timestampOfLastStationCompletion: string;
  lastCompletedStationAt: string;
  timeSpentInLe: number;
  timestampOfStart: string;
  timestampOfEnd: string;
  enteredLearningExperienceAt: string;
  exitedLearningExperienceAt: string;
};

export type ChatReports = {
  id: string;
  learningExperienceName: string;
  roomId: string;
  whatWasSaid: string;
  userId: string;
  userName: string;
  timestamp: string;
  scriptedOrQA: string;
};

export type SessionVrUser = {
  id: string;
  firebaseId: string;
  first_name: string;
  last_name: string;
  email: string;
  logs: Log[];
  isGuest?: boolean;
};

export type Session = {
  roomId: string;
  duration: number;
  logId: string[];
  startedAt: string;
  sessionId: string;
  usersQuantity: number;
  users: SessionVrUser[];
  school: School;
  timezone: string;
  streamId?: string;
  streamUrl?: string;
  streamStatus?: EStreamStatus;
  InternalId?: string;
  answerReports?: AnswerReports[];
  progressReports?: ProgressReports[];
  chatReports?: ChatReports[];
  dataSource?: string;
  endedAt?: string;
  userRole?: string;
};

export type TableSession = {
  key: string;
  id: string;
  roomId: string;
  startedAt: string;
  duration: string;
  users: SessionVrUser[];
  userName: string;
  email: string;
  school: string;
  streamUrl?: string;
  streamStatus?: EStreamStatus;
  InternalId?: string;
  answerReports?: AnswerReports[];
  progressReports?: ProgressReports[];
  chatReports?: ChatReports[];
  dataSource?: string;
  endedAt?: string;
  userRole?: string;
};
